<button mat-icon-button class="clear-button" (click)="close()" data-cy="forms-builder-creation-close-button"><i class="material-icons">clear</i></button>
@if (mode == 'create') {
  <div class="main-container" data-cy="forms-builder-creation-container">
    <h4 data-cy="forms-builder-creation-title">Create a form</h4>
    @if (!subMode) {
      <p data-cy="forms-builder-creation-intro">Would you like to create a new form or duplicate an existing form?</p>
    }
    @if (subMode == 'duplicate') {
      <p data-cy="forms-builder-creation-duplicate-intro">Search for a form to duplicate.</p>
    }
    @if (subMode == 'create') {
      <p data-cy="forms-builder-creation-create-intro">Enter a name for the new form.</p>
    }
    @if (!subMode) {
      <button mat-raised-button color="primary" class="menu-button" (click)="subMode='create'" data-cy="forms-builder-creation-new-button">
        <mat-icon aria-hidden="true">add</mat-icon>Create a new form
      </button>
    }
    @if (!subMode) {
      <button mat-raised-button color="primary" class="menu-button" (click)="initDuplicateMode()" data-cy="forms-builder-creation-duplicate-button">
        <mat-icon aria-hidden="true">content_copy</mat-icon>Duplicate a form
      </button>
    }
    @if (subMode == 'duplicate') {
      <div data-cy="forms-builder-creation-duplicate-container">
        <div class="form-search-container" data-cy="forms-builder-creation-search-container">
          <input class="form-search-input" type="text" placeholder="Search for form by name"
            (input)="searchForForm($event.target.value)" data-cy="forms-builder-creation-search-input" autocomplete="off" />
          <div class="form-search-results" data-cy="forms-builder-creation-search-results">
            @if (isSearchingForForms) {
              <div class="search-spinner-holder" data-cy="forms-builder-creation-search-spinner">
                <mat-spinner [diameter]="20" data-cy="forms-builder-creation-spinner"></mat-spinner>
              </div>
            }
            @if (!isSearchingForForms) {
              <div data-cy="forms-builder-creation-results-content">
                @if (!formSearchResults) {
                  <div class="search-message" data-cy="forms-builder-creation-empty-message">
                  </div>
                }
                @if (formSearchResults && !formSearchResults.length) {
                  <div class="search-message" data-cy="forms-builder-creation-no-results">
                    No forms found
                  </div>
                }
                @for (formPreview of formSearchResults; track formPreview; let i = $index) {
                  <div class="form-preview" (click)="selectCfgForm(formPreview)" [class.selected]="selectedFormId == formPreview.DFormId"
                    data-cy="forms-builder-creation-form-preview-{{i}}">
                    {{ formPreview.DFormName }}
                  </div>
                }
              </div>
            }
          </div>
          @if (selectedFormPreview) {
            <input class="new-name-input" type="text" placeholder="Enter a new name" [(ngModel)]="newFormName" data-cy="forms-builder-creation-name-input" />
            <div class="duplicate-submit-wrapper">
              <button mat-raised-button class="duplicate-submit-button" [disabled]="!newFormName" (click)="submitDuplicateForm(selectedFormPreview)" data-cy="forms-builder-creation-duplicate-submit">Duplicate form</button>
            </div>
          }
        </div>
      </div>
    }
    @if (subMode == 'create') {
        <div data-cy="forms-builder-creation-create-container">
          <div class="create-input-container" data-cy="forms-builder-creation-create-input-container">
            <div data-cy="forms-builder-creation-create-name-container">
              <input class="new-name-input" type="text" placeholder="Enter a new name" [(ngModel)]="newFormName" data-cy="forms-builder-creation-create-name-input" />
            </div>
            <button mat-raised-button color="primary" (click)="submitNewForm()" [disabled]="!newFormName" data-cy="forms-builder-creation-create-submit">Create form</button>
          </div>
        </div>
      }
    </div>
  }

  @if (mode == 'edit') {
    <div class="main-container" data-cy="forms-builder-edit-container">
      <h4 data-cy="forms-builder-edit-title">Edit a form</h4>
      @if (!subMode) {
        <p data-cy="forms-builder-edit-intro">Would you like to create a new version, copy an existing version, edit an existing version or delete the form?</p>
      }
      @if (subMode == 'copy') {
        <p data-cy="forms-builder-edit-copy-intro">Select the version you want to copy.</p>
      }
      @if (subMode == 'edit') {
        <p data-cy="forms-builder-edit-version-intro">Select the version you want to edit.</p>
      }
      @if (!subMode) {
        <button mat-raised-button color="primary" class="menu-button" (click)="submitNewVersion()" data-cy="forms-builder-edit-new-version">Create a new version</button>
      }
      @if (!subMode) {
        <button mat-raised-button color="primary" class="menu-button" [disabled]="!existingVersions.length" (click)="subMode = 'copy'" data-cy="forms-builder-edit-copy-version">Copy a version</button>
      }
      @if (!subMode) {
        <button mat-raised-button color="primary" class="menu-button" [disabled]="!existingVersions.length" (click)="subMode = 'edit'" data-cy="forms-builder-edit-version">Edit a version</button>
      }
      @if (!subMode) {
        <button mat-raised-button color="warn" class="menu-button" (click)="deleteForm()" data-cy="forms-builder-edit-delete">Delete this form</button>
      }
      @if (subMode == 'copy' || subMode == 'edit') {
        <div data-cy="forms-builder-edit-version-container">
          <div class="form-search-results" data-cy="forms-builder-edit-versions-list">
            <div data-cy="forms-builder-edit-versions-content">
              @for (version of existingVersions; track version; let i = $index) {
                <div class="form-preview" (click)="selectCfgVersion(version)"
                  data-cy="forms-builder-edit-version-preview-{{i}}">
                  {{ version.Version }}
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
